import { createFileRoute } from '@tanstack/react-router'
import { CustomPageEditor } from './-custom-page-editor'
import { loadCreateCustomPageRoute } from './-loader'

export const Route = createFileRoute('/_authenticated/$orgId/website/custom-pages/create')({
  component: CustomPageEditor,
  loader: loadCreateCustomPageRoute,
})
